export default "__VITE_ASSET__86792657__"